import React, { useState } from "react";
import { sendPasswordResetEmail } from "firebase/auth";
import { auth } from "../../Config/firebase";
import "./styles.scss";

function ForgotPassword({ switchLogin }) {
  const [error, setError] = useState("");
  const [email, setEmail] = useState("");
  const [success, setSuccess] = useState("");

  async function handleForgot(e) {
    e.preventDefault();
    setError("");
    setSuccess("");
    
    if (!email) {
      setError("Please enter your email address.");
      return;
    }
    
    try {
      await sendPasswordResetEmail(auth, email);
      setSuccess("Password reset email sent. Check your inbox.");
    } catch (err) {
      setError(err.message || "Failed to send password reset email.");
    }
  }

  return (
    <div className="login-container">
      <div className="login-box">
        {error && <div className="error-message">{error}</div>}
        <form className="login-form" onSubmit={handleForgot}>
          <div className="form-group">
            <input
              id="email"
              type="email"
              placeholder="Email"
              required
              className="login-form-input"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
          </div>
          <button type="submit" className="login-button">Send Email</button>
          {success && <div className="success-message">{success}</div>}
          <div className="signup-prompt">
            <div className="link-button" onClick={() => switchLogin("login")}>
              Login
            </div>
            |
            <div className="link-button" onClick={() => switchLogin("create")}>
              Create an account
            </div>
          </div>
        </form>
      </div>
    </div>
  );
}

export default ForgotPassword;
